// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2ajWj","header":"ReportDetails_header__1NQWf","title":"ReportDetails_title__10O_L","left":"ReportDetails_left__3_6ZX"};